import { Navigate, useLocation } from "react-router-dom";
import { useAdminSession } from "@/lib/admin/auth";

interface Props {
  children: React.ReactNode;
  requireSuperAdmin?: boolean;
}

const AdminGuard = ({ children, requireSuperAdmin }: Props) => {
  const { loading, session, admin, error } = useAdminSession();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0F1A2E]">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#C89B3C] border-t-transparent" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  }

  if (!admin) {
    return <Navigate to="/admin/forbidden" replace state={{ error }} />;
  }

  if (requireSuperAdmin && admin.role !== "super_admin") {
    return <Navigate to="/admin/forbidden" replace />;
  }

  return <>{children}</>;
};

export default AdminGuard;
